'use client';

import getYouTubeId from '@/helpers/getYouTubeId';
import Script from 'next/script';
import { useEffect } from 'react';

export interface YouTubeEmbedProps {
	testId?: string;
	media_url: string;
}

export const onPlayerStateChange = (event: YT.OnStateChangeEvent) => {
	const iframe = event.target.getIframe();
	const videoData = iframe.dataset;
	const videoTitle = videoData.videotitle || 'unknown_video_title';
	switch (event.data) {
		case window.YT.PlayerState.PLAYING:
			window.heap?.track('Video Play', {
				'Video ID': videoData.videoid ?? '',
				title: videoTitle,
			});
			break;
		case window.YT.PlayerState.ENDED:
			window.heap?.track('Video Finished', {
				'Video ID': videoData.videoid ?? '',
				title: videoTitle,
			});
			break;
	}
};

const YouTubeEmbed = (props: YouTubeEmbedProps) => {
	const { testId = 'YouTubeEmbed', media_url } = props;
	const videoComponentId = getYouTubeId(media_url);

	useEffect(() => {
		function onYouTubeIframeAPIReady() {
			const videos = Array.from(
				document.querySelectorAll('[data-videoid]'),
			) as HTMLIFrameElement[];
			videos.map((video) => {
				const { videoid } = video.dataset;

				if (!videoid) return;

				new window.YT.Player(videoid, {
					videoId: videoid,
					events: {
						onStateChange: onPlayerStateChange,
					},
				});
			});
		}

		window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

		return () => {
			window.onYouTubeIframeAPIReady = undefined;
		};
	}, []);

	if (!videoComponentId) return null;

	return (
		<div test-testid={testId}>
			<Script
				src="https://www.youtube.com/iframe_api"
				strategy="afterInteractive"
			/>

			<div
				id={videoComponentId}
				data-videoid={videoComponentId}
				className="aspect-video h-full w-full"
			></div>
		</div>
	);
};

export default YouTubeEmbed;
